import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { Box } from "@mui/material";
import type { FC } from "react";
import { InHouseTooltip } from "@/components/InHouseTooltip/InHouseTooltip";
import { gridCellStyle } from "@/pages/MasterSchedule/v2/utils";
import type { DayNurseData } from "../utils";
import { countAssignedShiftsForLocation } from "../utils";

type Props = {
	weekData: DayNurseData[];
	targetVisits: number;
};

export const SynergyVisitsCell: FC<Props> = ({ weekData, targetVisits }) => {
	// Count total assigned nurses across the week
	const assignedCount = countAssignedShiftsForLocation(weekData);

	// Check if we're missing shifts
	const missing = assignedCount < targetVisits;

	return (
		<Box sx={{ ...gridCellStyle, display: "flex", gap: 1, alignItems: "center", flexDirection: "row" }}>
			<InHouseTooltip title={"Assigned this week / Target visits per week"}>
				<span>
					{assignedCount} / {targetVisits}
				</span>
			</InHouseTooltip>
			{missing && (
				<InHouseTooltip title={"Missing Shifts"}>
					<WarningAmberOutlined
						fontSize={"inherit"}
						sx={{
							color: "#E71C00CC",
							fontSize: "16px",
						}}
					/>
				</InHouseTooltip>
			)}
		</Box>
	);
};
